import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from '@bd/bdui-styles/emotion';
import CoreMap from '@bd/bdui-coremap';
import { GoogleMapUrl, SanitizeHtml } from '@bd/bdcore-utilities';
import AccordionToggle from './AccordionToggle';
import { colors, typography } from '../styles';

const styles = css`
.AccordionToggle_content {
  background-color: #000000;
  text-align: center;
  line-height: 31px;
  margin-bottom: 35px;
  margin: 0;
  color: #FFFFFF;
  padding: 0 0 50px;
  @media (min-width: 992px) {
    padding: 100px 0;
  }
}
  .SectionDirections_directionsWrapper{
    @media(min-width: 768px){
      max-width: 1600px;
      margin: auto;
    }
  }
  .SectionDirections_head {
    display: none;
    @media (min-width: 768px) {
      display: block;
      margin-bottom: 1.083333em;
    }
  }
  .SectionDirections_mapDirectionsWrapper {
    @media (min-width: 992px) {
      display: flex;
    }
  }
  .SectionDirections_mapWrapper {
    @media (min-width: 992px) {
      width: 40.175439%;
      flex-shrink: 0;
    }
  }
  .SectionDirections_map {
    height: 240px;
    .leaflet-container {
      z-index: 0;
    }
    .leaflet-marker-icon {
      cursor: -webkit-grab;
      cursor: grab;
    }
    @media (min-width: 768px) {
      height: 375px;
    }
  }
  .SectionDirections_directions {
    margin: 16px 20px;
    @media (min-width: 768px) {
      margin: 20px;
    }
    @media (min-width: 992px) {
      margin: 0 30px;
    }
  }
  .SectionDirections_directionsText {
    font-size: 15px;
    font-weight: 300;
    letter-spacing: 0.025333em;
    line-height: 1.941176;
    margin: 0;
    @media (min-width: 768px) {
      font-size: 16px;
    }
    @media (min-width: 992px) {
      font-size: 17px;
      text-align: left;
    }
  }
  .SectionDirections_googleMapLinkWrapper {
    font-size: 15px;
    font-weight: bold;
    line-height: 1.25;
    letter-spacing: 0.025333em;
    margin-top: 10px;
    margin-bottom: 0;
    @media (min-width: 768px) {
      font-size: 16px;
    }
    @media (min-width: 992px) {
      font-size: 17px;
    }
  }
  .SectionDirections_googleMapLink {
    color: ${colors.color1};
  }
  .SectionDirections_newWindowIcon {
    width: 10px;
    margin-left: 2px;
    @media (min-width: 992px) {
      width: 12px;
      margin-left: 3px;
    }
  }
  .SectionDirections_sectionHead {
    font-family: ${typography.SerifHead};
    font-weight: bold;
    letter-spacing: 0.62px;
    font-style: italic;
    margin-bottom: 0.625em;
  }
`;


function SectionDirections({ className, marker, directions }) {
  return (
    <div className={cx(styles, className)}>
      <AccordionToggle
        openOnId="directions"
        button="Map &amp; Directions"
        id="directions"
      >
        <section className="SectionDirections_directionsWrapper">
          <h3 className="SectionDirections_sectionHead SectionDirections_head GoldText">Map &amp; Directions</h3>
          <div className="SectionDirections_mapDirectionsWrapper">
            <div className="SectionDirections_mapWrapper">
              <CoreMap
                pin={{
                  iconUrl: '/images/i-map-pin-alt.svg',
                  iconSize: [29, 38],
                  iconAnchor: [14.5, 38],
                }}
                className="SectionDirections_map"
                markers={[marker]}
              />
              <p className="SectionDirections_googleMapLinkWrapper">
                <a
                  className="SectionDirections_googleMapLink"
                  href={GoogleMapUrl(marker)}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Open on Google Maps
                  <sup>
                    <img
                      className="SectionDirections_newWindowIcon"
                      src="/images/i-new-window.svg"
                      alt="opens in a new tab"
                    />
                  </sup>
                </a>
              </p>
            </div>
            {
              directions &&
              <div className="SectionDirections_directions">
                <div className="SectionDirections_directionsText" dangerouslySetInnerHTML={SanitizeHtml(directions)} />
              </div>
            }
            {
              !directions &&
              <div className="SectionDirections_directions">
                <div className="SectionDirections_directionsText">No specific directions available for this property at this time.</div>
              </div>
            }
          </div>
        </section>
      </AccordionToggle>
    </div>
  );
}

SectionDirections.propTypes = {
  className: PropTypes.string,
  directions: PropTypes.string,
  marker: PropTypes.shape({
    geoIndexed: PropTypes.arrayOf(PropTypes.number),
    _id: PropTypes.string,
  }).isRequired,
};

SectionDirections.defaultProps = {
  className: undefined,
  directions: undefined,
};

export default SectionDirections;



// WEBPACK FOOTER //
// ./src/components/SectionDirections.js